import { Component, Suspense } from 'react';
import LoadingIndicator from './LoadingIndicator';
import Button from './Button';

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  hasChunkError: boolean;
}

export class ChunkErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = { hasChunkError: false };

  static getDerivedStateFromError(error: Error) {
    const isChunkError =
      error.name === 'ChunkLoadError' ||
      error.message?.includes('Failed to fetch dynamically imported module') ||
      error.message?.includes('error loading dynamically imported module') ||
      error.message?.includes('Importing a module script failed') ||
      error.message?.includes('Loading chunk') ||
      error.message?.includes('Loading CSS chunk');

    if (isChunkError) {
      return { hasChunkError: true };
    }

    throw error;
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasChunkError) {
      return (
        <div className="full-width text-center mt-5">
          <section className="content-width">
            <h2 className="fz-24 font-yettel mb-4">
              Dostupna je nova verzija aplikacije.
            </h2>
            <Button onClick={this.handleReload}>Osveži stranicu</Button>
          </section>
        </div>
      );
    }

    return this.props.children;
  }
}

const SuspenseWrapper = ({ children }: { children: React.ReactNode }) => (
  <ChunkErrorBoundary>
    <Suspense fallback={<LoadingIndicator customMarginClasses="mt-3 mb-2" />}>
      {children}
    </Suspense>
  </ChunkErrorBoundary>
);

export default SuspenseWrapper;
